export default __webpack_public_path__ + "static/TSD_Header_2-0b63a10526b01b1361245e0f0b752beb.jpg";